
import React from "react";
import { TimeTable } from "./TimeTable";

export class RenderTimeTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = { date: new Date() };
  }

  componentDidMount() {
    this.timerID = setInterval(() => this.tick(), 1000);
  }

  componentWillUnmount() {
    clearInterval(this.timerID);
  }

  tick() {
    this.setState({
      date: new Date()
    });
    //console.log(this.state.date);
  }
  render() {
    return (
      <div>
        <TimeTable
          nowTime={("0"+this.state.date.getHours()).slice(-2) + ":" + ("0"+this.state.date.getMinutes()).slice(-2)}
        />
      </div>
    );
  }
}
